import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';
import { useDispatch } from '@shared/store';
import { FlagName, Flags, defaultFlags } from '@shared/util/featureFlags/launchDarkly/shared';

export function useSetBusinessId(businessId: number) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'UPDATE_CURRENT_BUSINESS_ID',
      value: { businessId },
    });
  }, [businessId, dispatch]);
}

export function useInitLaunchDarkly(businessId: number) {
  const [identified, setIdentified] = useState(false);
  const ldClient = useLDClient();

  useEffect(() => {
    if (!ldClient || !businessId || identified) {
      return;
    }

    ldClient.identify({
      key: `org-${businessId}`,
      custom: {
        businessId,
      },
    });

    setIdentified(true);
  }, [ldClient, businessId, identified]);
}

export function useFeatureFlag<T extends FlagName>(flagName: T): Flags[T] {
  const flags = useFlags();

  return flags[flagName] ?? defaultFlags[flagName];
}

export * from '@shared/util/featureFlags/launchDarkly/shared';
